import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LoginPage } from './pages/AuthPages';
import { DashboardPage } from './pages/DashboardPage';
import { DealDetailPage } from './pages/DealDetailPage';
import { StipTrackerPage } from './pages/StipTrackerPage';
import { InterviewConciergePage } from './pages/InterviewConciergePage';
import { ComplianceLogPage } from './pages/ComplianceLogPage';
import { SettingsPage } from './pages/SettingsPage';
import { CustomerUploadPage } from './pages/CustomerUploadPage';
import { ArchivedDealsPage } from './pages/ArchivedDealsPage';
import { FundedDealsPage } from './pages/FundedDealsPage';
import { UnwindsPage } from './pages/UnwindsPage';
import InterviewCalendarPage from './pages/InterviewCalendarPage';
import { Toaster } from './components/ui/sonner';
import { WebSocketProvider } from './contexts/WebSocketContext';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-slate-300 border-t-slate-900 animate-spin mx-auto mb-4" />
          <p className="text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deal/:id"
        element={
          <ProtectedRoute>
            <DealDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stip-tracker"
        element={
          <ProtectedRoute>
            <StipTrackerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews"
        element={
          <ProtectedRoute>
            <InterviewConciergePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/calendar"
        element={
          <ProtectedRoute>
            <InterviewCalendarPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/compliance"
        element={
          <ProtectedRoute>
            <ComplianceLogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/archived"
        element={
          <ProtectedRoute>
            <ArchivedDealsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/funded"
        element={
          <ProtectedRoute>
            <FundedDealsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/unwinds"
        element={
          <ProtectedRoute>
            <UnwindsPage />
          </ProtectedRoute>
        }
      />
      {/* Public customer upload route - no auth required */}
      <Route path="/customer-upload" element={<CustomerUploadPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <WebSocketProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </WebSocketProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
